import { createIcon } from '@chakra-ui/react';

export const RegenerateIcon = createIcon({
  displayName: 'RegenerateIcon',
  viewBox: '0 0 16 16',
  path: (
    <g clipPath="url(#clip0_regenerate)">
      <path
        d="M0.666504 13.3332V9.33322M0.666504 9.33322H4.6665M0.666504 9.33322L3.75984 12.2399C4.47634 12.9567 5.36275 13.4804 6.33638 13.762C7.31 14.0437 8.3391 14.0741 9.32765 13.8504C10.3162 13.6267 11.232 13.1563 11.9895 12.4829C12.7471 11.8096 13.3217 10.9554 13.6598 9.99989M15.3332 2.66655V6.66655M15.3332 6.66655H11.3332M15.3332 6.66655L12.2398 3.75989C11.5233 3.04303 10.6369 2.51936 9.6633 2.23774C8.68967 1.95612 7.66058 1.92572 6.67203 2.14939C5.68348 2.37306 4.7677 2.84351 4.01015 3.51683C3.25259 4.19016 2.67795 5.04441 2.33984 5.99989"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <defs>
        <clipPath id="clip0_regenerate">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </g>
  ),
});
